<div *ngIf="(pageVm$ | async) as pvm">

    <!-- loader -->
    <app-page-loader [pageLoaderVm]="pvm"></app-page-loader>

    <!-- header -->
    <app-page-header *ngIf="pvm.pageHeaderVm" [pageHeaderVm]="pvm.pageHeaderVm"
        (backClicked)="backClicked(pvm)" (editClicked)="editClicked(pvm)"
        (prevClicked)="prevClicked(pvm.contentVm)" (nextClicked)="nextClicked(pvm.contentVm)"
    ></app-page-header>


    <!-- content -->
    <div *ngIf="pvm.contentVm as vm">

        <!-- forms -->
        <div *ngIf="vm.formVm as fvm">
            <div class="row">
                <div class="col-md-12">

                    <!-- edit -->
                    <div *ngIf="fvm.type == 'edit'">

                        <mdb-card narrower="true" cascade="true">
                            <div class="row">
                                <div class="col-md-6">
                                    <app-card-header [headingSize]="2" [title]="fvm.title">
                                    </app-card-header>
                                </div>
                            </div>
                            <mdb-card-body cascade="true">

                                <div class="row">
                                </div>

                            </mdb-card-body>
                        </mdb-card>

                    </div>

                    <!-- ok / cancel -->
                    <div *ngIf="fvm.okCancelVm" class="pt-2">
                        <app-form-ok-cancel [vm]="fvm.okCancelVm" (okClicked)="editFormComplete(pvm, fvm)"
                            (cancelClicked)="formCancel(pvm)">
                        </app-form-ok-cancel>
                    </div>

                </div>
            </div>
        </div>
    
    </div>
</div>